var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tw-flex tw-items-center"},[_c('CCheckbox',{attrs:{"model-value":_vm.checked},on:{"change":_vm.handleChange}},[_vm._v("\n    "+_vm._s(_vm.$t('prices'))+" "+_vm._s(_vm.$t('with vat').toLowerCase())+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }